import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

Sentry.init({
  dsn: 'https://b85d11881b8f4b029af60f8b1162b026@o264095.ingest.sentry.io/5917578',
  ignoreErrors: ['Invalid or expired token'],
  enabled: process.env.NODE_ENV !== 'development',
  environment: (() => {
    const { origin } = window.location;

    if (origin.includes('demo')) {
      return 'demo';
    } else if (origin.includes('staging')) {
      return 'staging';
    } else {
      return 'production';
    }
  })(),
  beforeSend (event, hint) {
    const error = hint.originalException;
    if (!error.response) { return event; }

    const { status } = error.response;
    if (status >= 400 && status <= 499) { return null; }

    return event;
  }
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
